import { render, staticRenderFns } from "./OrganizationDialog.vue?vue&type=template&id=18f19475&scoped=true&"
import script from "./OrganizationDialog.vue?vue&type=script&lang=js&"
export * from "./OrganizationDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationDialog.vue?vue&type=style&index=0&id=18f19475&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f19475",
  null
  
)

export default component.exports